import React, { useState, useEffect } from "react";
import ColoredLine from "../common/coloredLine";
import { fetchHtmlPageByName } from "../../services/htmlPageService";

const Home = () => {
  const [htmlContent, setHtmlContent] = useState("");
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  useEffect(() => {
    fetchHtmlPageByName("homepage")
      .then((response) => {
        setHtmlContent(response.data.content);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching the HTML page content:", error);
        setError("Failed to load content");
        setLoading(false);
      });
  }, []);

  if (loading) return <div>Loading...</div>; // Display loading indicator
  if (error) return <div>{error}</div>; // Display error message if any

  const pId = Math.floor(Math.random() * (5 - 1 + 1)) + 1;

  return (
    <>
      <div className="col text-center">
        <img
          src={require("../../img/masthead" + pId + ".png")}
          className="img-fluid"
          alt=""
        />
      </div>

      <ColoredLine color="#779442" />

      <div className="container text-center">
        <div className="row align-items-start">
          <div className="col-md-6">

              <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
     
          </div>
          <div className="col-md-6">
            <img
              src={require("../../img/home_AwardPie_2022.png")}
              style={{ width: "90%" }}
              alt=""
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
